/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetBbsCategoryTreeRespVo } from './GetBbsCategoryTreeRespVo';
import {
    GetBbsCategoryTreeRespVoFromJSON,
    GetBbsCategoryTreeRespVoFromJSONTyped,
    GetBbsCategoryTreeRespVoToJSON,
    GetBbsCategoryTreeRespVoToJSONTyped,
} from './GetBbsCategoryTreeRespVo';

/**
 * 
 * @export
 * @interface ResponseListGetBbsCategoryTreeRespVo
 */
export interface ResponseListGetBbsCategoryTreeRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListGetBbsCategoryTreeRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListGetBbsCategoryTreeRespVo
     */
    message?: string;
    /**
     * 
     * @type {Array<GetBbsCategoryTreeRespVo>}
     * @memberof ResponseListGetBbsCategoryTreeRespVo
     */
    data?: Array<GetBbsCategoryTreeRespVo>;
}

/**
 * Check if a given object implements the ResponseListGetBbsCategoryTreeRespVo interface.
 */
export function instanceOfResponseListGetBbsCategoryTreeRespVo(value: object): value is ResponseListGetBbsCategoryTreeRespVo {
    return true;
}

export function ResponseListGetBbsCategoryTreeRespVoFromJSON(json: any): ResponseListGetBbsCategoryTreeRespVo {
    return ResponseListGetBbsCategoryTreeRespVoFromJSONTyped(json, false);
}

export function ResponseListGetBbsCategoryTreeRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListGetBbsCategoryTreeRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(GetBbsCategoryTreeRespVoFromJSON)),
    };
}

export function ResponseListGetBbsCategoryTreeRespVoToJSON(json: any): ResponseListGetBbsCategoryTreeRespVo {
    return ResponseListGetBbsCategoryTreeRespVoToJSONTyped(json, false);
}

export function ResponseListGetBbsCategoryTreeRespVoToJSONTyped(value?: ResponseListGetBbsCategoryTreeRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(GetBbsCategoryTreeRespVoToJSON)),
    };
}

